import {NgModule} from '@angular/core';
import {TimeAgoPipe} from './time-ago';
import {DateFormatPipe} from './format-date.pipe';

export const DATE_PIPES = [TimeAgoPipe, DateFormatPipe ];

@NgModule({
  declarations: DATE_PIPES,
  imports: [],
  exports: DATE_PIPES,
})
export class NgDatePipesModule {}

export { TimeAgoPipe } from './time-ago';
export { DateFormatPipe } from './format-date.pipe';
export { EndOfMonthPipe } from './end-of-month.pipe';
export { StartOfMonthPipe } from './start-of-month.pipe';
